import React from 'react';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';

import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';

import { useOrderVolumeProfileConfigSlice } from 'widgets/orderVolumeProfile/store/configuration/configSlice.ts';
import {
    orderVolumeProfileColumnsDefinitions,
    OrderVolumeProfileGridColumn,
} from 'widgets/orderVolumeProfile/components/grid/columns.tsx';
import { initialOrderVolumeProfileConfiguration } from 'widgets/orderVolumeProfile/store/configuration/OrderVolumeProfileConfiguration.ts';

export default function OrderVolumeProfileColumnPicker() {
    const {
        config: { visibleColumns },
    } = useOrderVolumeProfileConfigSlice();

    const allPickableItems: PickableItem<OrderVolumeProfileGridColumn>[] =
        orderVolumeProfileColumnsDefinitions.map((column) => ({
            value: column.field as OrderVolumeProfileGridColumn,
            name: column.name || column.field!,
            desc: column.headerTooltip ?? column.name,
        }));

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (cols: OrderVolumeProfileGridColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                initialOrderVolumeProfileConfiguration.visibleColumns
            }
            allItems={allPickableItems}
            onUpdateSelectedValues={onUpdateVisibleColumns}
            hideGroupView={true}
        />
    );
}
